// extracted by mini-css-extract-plugin
export default {"Loading":"_Loading--aS3s0"};